export default {
    backend_url_users: "http://localhost:5000/api/users/",
    backend_asset_url: "http://localhost:5000/"
}